import * as React from "react";
import ReactDOM from "react-dom";
import { useEffect, useState } from "react";
import { HeaderTitle } from "../components/header/title/headerTitle.component";
import { LabelContext } from "../core/label.context";
import { GeneralContext } from "../core/general.context";
import { StyledPages } from "./commonPages.style";
import { CartContext } from "../core/cart.context";
import {calls, PROJECT_COUNTRY} from "../core/APIUtils";
import { RESTContext } from "../core/rest.context";
import { getAnalyticsProducts, parsePrice, redirectTo } from "../common/constants";
import {ThankYouMessage} from "./CheckoutPage";

export const PayUConfirmationPage = (_props: any) => {
    const [orderId, setOrderId] = useState<string>();
    const [payUOrder, setPayUOrder] = useState<any>();
    const container = document.getElementById("reactPlaceholder_payu-confirmation");
    const { t } = React.useContext(LabelContext);
    const { userData, payU } = React.useContext(GeneralContext);
    const { getPayUCreate } = React.useContext(CartContext);
    const { ajax$ } = React.useContext(RESTContext);
    const localStorage = (window as any).localStorage || []
    const dataLayer = (window as any).dataLayer || []
    const analytics: any = localStorage?.analytics ? JSON.parse(localStorage?.analytics) : {}

    useEffect(() => {
        let params: URLSearchParams = new URLSearchParams(window.location.search)
        if (params?.get("error") && params?.get("error") === '501') {
            redirectTo('checkout?status=error');
        }
        else if (params?.get("cartid")) {
            const sid: string = params?.get("cartid") || ""
            setOrderId(sid);
        }
    }, [])

    useEffect(() => {
        if (orderId) {
            getPayUCreate(orderId)
        }
    }, [orderId])

    useEffect(() => {
        if (payU) {
            if (payU.code > 302){
                redirectTo('checkout?status=error');
            }
            else if (payU?.obj?.ctOrder) {
                setPayUOrder(payU.obj.ctOrder);
            } else {
                if (payU?.obj?.cartId) {
                    ajax$(calls.Project.getMyCartById(payU?.obj?.cartId))
                        .subscribe(
                            res => {
                                setPayUOrder(res);
                            }
                        );
                } 
            }
        }
    }, [payU])

    useEffect(() => {
        if (payUOrder) {
            dataLayer.push({
                pageLang: `${analytics?.currentLang || ""}`,
                pageType: `${payUOrder ? "purchase" : analytics?.pageType}`,
                visitorId: `${userData?.id}`,
                visitorLoginState: `${userData?.id ? "logged-in" : "not-logged"}`,
                visitorNewsletterSubscription: `${userData?.custom?.fields?.subscribed ? "yes" : "no"}`,
                visitorEmail: payUOrder.customerEmail
            })

            dataLayer.push({
                event: "checkoutOption",
                ecommerce: {
                    checkout_option: {
                        actionField: {
                            step: 2,
                            option: [
                                `${payUOrder?.shippingInfo?.shippingMethodName} - ${payUOrder?.paymentInfo?.payments[0]?.obj?.paymentMethodInfo?.paymentInterface}`,
                            ],
                        },
                    },
                },
            })

            const { lineItems } = payUOrder

            dataLayer.push({
                pageType: "purchase",
                visitorId: `${userData?.id}`,
            })

            let actionField: any = {
                id: `${payUOrder?.orderNumber || payUOrder?.id}`,
                affiliation: 'Online store',
                revenue: `${parsePrice(payUOrder?.totalPrice, true)}`,
                tax: `${parsePrice(payUOrder?.taxedPrice?.taxPortions[0]?.amount, true)}`,
                shipping: `${payUOrder?.shippingInfo?.price?.centAmount}`,
                coupon: `${payUOrder?.discountCodes?.map((item: any) => { return item?.discountCode?.obj?.code }).toString()}`,
            }

            if (["PL"].includes(PROJECT_COUNTRY)) {
                actionField.ceneoReviewConsent = payUOrder?.custom?.fields?.ceneoReviewConsent ?? false
            }

            dataLayer.push({
                event: 'purchase',
                ecommerce: {
                    currencyCode: `${payUOrder?.totalPrice?.currencyCode}`,
                    purchase: {
                        actionField: actionField,
                        products: getAnalyticsProducts(lineItems),
                    }
                }
            })
        } else {
            dataLayer.push({
                'pageLang': `${analytics?.currentLang}`,
                'pageType': `${analytics?.pageType ? analytics?.pageType : (analytics?.sitemap === 'root') ? 'homepage' : 'other'}`,
                'visitorId': `${userData?.id}`,
                'visitorLoginState': `${userData?.id ? 'logged-in' : 'not-logged'}`,
                'visitorNewsletterSubscription': `${userData?.custom?.fields?.subscribed ? 'yes' : 'no'}`,
            });
        }
    }, [payUOrder])

    if (!container)
        return null;
    else
        return ReactDOM.createPortal(
            <>
            {!payUOrder && <div className="isLoading" />}
            {payUOrder && <ThankYouMessage currentOrder={payUOrder} />}
            </>
            , container
        )
}
